import { ThrowableStatus } from "@wss/error-tracking/throwable";

type Brand = {
  name: string;
  image: string;
  link: string;
};

const getBrandsByUrl = async (
  urls: string[],
): Promise<ThrowableStatus<Brand[]>> => {
  try {
    const response = await fetch("/api/brandsbyurl/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ urls }),
    });

    if (!response.ok) {
      return {
        isError: true,
        status: response.status,
        error: new Error(response.statusText),
      };
    }

    return { isError: false, value: await response.json() };
  } catch (e) {
    return {
      isError: true,
      status: null,
      error: new Error("Failed to fetch brands by url.", { cause: e }),
    };
  }
};

export default getBrandsByUrl;
